import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ darkMode: 'appConfig/darkMode' }),
    isDark() {
      return this.darkMode === 'dark';
    },
    isLight() {
      return this.darkMode === 'light';
    },
    isAuto() {
      return this.darkMode === 'auto';
    },
  },
  mounted() {
    if (this.isAuto) {
      this.startWatchSystemDarkMode();
    }
  },
  methods: {
    startWatchSystemDarkMode() {
      window
        .matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', event => {
          this.$store.dispatch(
            'appConfig/setDarkMode',
            event.matches ? 'dark' : 'light'
          );
        });
    },
    getIsSystemInDarkMode(light, dark) {
      if (window?.matchMedia('(prefers-color-scheme: dark)')?.matches) {
        return dark;
      }

      if (window?.matchMedia('(prefers-color-scheme: light)')?.matches) {
        return light;
      }

      return '';
    },
    $dm(light, dark) {
      if (this.isLight) {
        return light;
      }

      if (this.isDark) {
        return dark;
      }

      return this.getIsSystemInDarkMode(light, dark);
    },
  },
};
